var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Wp_nav_bar',{attrs:{"title":"我的总预估收入详情(淘宝)","has-click":true},on:{"click":_vm.clickToBack}}),_c('Wp_tb_order_count_detail_model')],1)}
var staticRenderFns = []

export { render, staticRenderFns }